import React from 'react';
import { connect } from 'react-redux';
import MintingRow from './MintingRow';

const mapStateToProps = (state) => {
  return {
    coinsMinted: state.coinsMinted
  };
};

const connectedLatestCoinsMinted = ({coinsMinted}) => (
  <div className="c-component c-coins-minted">
    <h2>Latest Coins Minted</h2>
    <ul className="c-coins-minted__list">
      {coinsMinted
        .reverse()
        .slice(0, 10)
        .map((coinsMintedEvent) => (
          <li key={coinsMintedEvent.transactionHash} className="c-coins-minted__list-item">
            <MintingRow coinsMinted={coinsMintedEvent}/>
          </li>
        ))}
    </ul>
  </div>
);

const LatestCoinsMinted = connect(mapStateToProps)(connectedLatestCoinsMinted);

export default LatestCoinsMinted;



// WEBPACK FOOTER //
// ./src/components/AnalyticsPage/LatestCoinsMinted.js